import { VotingHome } from './VotingHome';
export default VotingHome;
